
  import { defineComponent, PropType } from 'vue';

  import { TDashboardRegionRepresentativeAbroadFilter } from '../../../types/regionDashboards';
  import RegionDashboardsRepresentativeAbroadBaseInfo from './RegionDashboardsRepresentativeAbroadBaseInfo.vue';
  import RegionDashboardsRepresentativeAbroadInfoTable from './RegionDashboardsRepresentativeAbroadInfoTable.vue';

  export default defineComponent({
    name: 'RegionDashboardsRepresentativeAbroadInfo',
    components: {
      RegionDashboardsRepresentativeAbroadBaseInfo,
      RegionDashboardsRepresentativeAbroadInfoTable,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardRegionRepresentativeAbroadFilter>,
        required: true,
      },
    },
  });
